import { useSelector } from "react-redux";
import { RootState } from "../store/store";
interface AppTitleProps{
  onIcons?: any;
}
const AppTitle:React.FC<AppTitleProps> = ({onIcons}) => {
  const { PAGE_TITLE } = useSelector((state: RootState) => state.software);
  return (
    <div className='w-full px-4 dark:bg-sky_850'>
      <div className='flex justify-between'>
        <h6 className='font-public-sans text-[13px] my-auto font-medium text-slate-600 capitalize dark:text-gray-400'>{PAGE_TITLE.title}</h6>
        <h6 className='font-public-sans font-bold text-sky-700 capitalize'>{onIcons}</h6>
      </div>
    </div>
  )
}

export default AppTitle